<template>
    <div>
        <div class="text-center mb-2">
            <h1 class="text-theme-primary text-3xl font-bold">
                Carga de inventario con archivo
            </h1>
            <p class="mt-2 text-theme-base max-w-2xl mx-auto text-sm">
                Sube y actualiza el inventario del comercio seleccionado de
                forma masiva usando un archivo. Elige la herramienta que mejor
                se adapte a lo que necesitas hacer.
            </p>
        </div>

        <div class="container mx-auto mt-6">
            <div class="flex flex-wrap justify-center gap-6">
                <router-link
                    to="/app/inventories/massive/load"
                    class="text-decoration-none w-full sm:w-80"
                >
                    <div
                        class="button-card h-full bg-brand-blue rounded-xl p-5 shadow-sm text-white flex flex-col"
                    >
                        <div class="flex items-start gap-3 mb-3">
                            <span class="text-4xl leading-none">📦</span>
                            <div>
                                <span
                                    class="inline-block text-xs font-semibold bg-white bg-opacity-20 text-white px-2 py-0.5 rounded-full mb-1"
                                >
                                    Suma unidades
                                </span>
                                <h5
                                    class="text-white font-semibold leading-tight"
                                >
                                    Carga masiva de inventario
                                </h5>
                            </div>
                        </div>

                        <p class="text-sm mb-3 opacity-90">
                            Agrega unidades al inventario del comercio sumando
                            las cantidades del archivo a las existentes.
                        </p>

                        <hr class="mb-3 opacity-20" />

                        <ul
                            class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90"
                        >
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span
                                    >Las referencias se identifican por código
                                    de barras</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span
                                    >Si la referencia no está en el inventario
                                    del comercio, se agrega
                                    automáticamente</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">➕</span>
                                <span
                                    >Si ya está en el inventario, las nuevas
                                    unidades se suman a las existentes</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">⏭</span>
                                <span
                                    >Si la referencia no existe en el sistema,
                                    será omitida</span
                                >
                            </li>
                        </ul>

                        <div
                            class="mt-4 text-center text-sm font-semibold text-white"
                        >
                            Ir a la herramienta →
                        </div>
                    </div>
                </router-link>

                <router-link
                    to="/app/inventories/massive/load-and-updates"
                    class="text-decoration-none w-full sm:w-80"
                >
                    <div
                        class="button-card h-full bg-brand-red rounded-xl p-5 shadow-sm text-white flex flex-col"
                    >
                        <div class="flex items-start gap-3 mb-3">
                            <span class="text-4xl leading-none">♻️</span>
                            <div>
                                <span
                                    class="inline-block text-xs font-semibold bg-white bg-opacity-20 text-white px-2 py-0.5 rounded-full mb-1"
                                >
                                    Sobrescribe unidades
                                </span>
                                <h5
                                    class="text-white font-semibold leading-tight"
                                >
                                    Carga masiva (Sobrescribiendo)
                                </h5>
                            </div>
                        </div>

                        <p class="text-sm mb-3 opacity-90">
                            Actualiza el inventario del comercio reemplazando
                            las unidades existentes con las del archivo.
                        </p>

                        <hr class="mb-3 opacity-20" />

                        <ul
                            class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90"
                        >
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span
                                    >Las referencias se identifican por código
                                    de barras</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span
                                    >Si la referencia no está en el inventario
                                    del comercio, se agrega
                                    automáticamente</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">🔄</span>
                                <span
                                    >Si ya está en el inventario, las unidades
                                    actuales son reemplazadas por las del
                                    archivo</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">⏭</span>
                                <span
                                    >Si la referencia no existe en el sistema,
                                    será omitida</span
                                >
                            </li>
                        </ul>

                        <div
                            class="mt-3 p-2 rounded-lg text-xs flex gap-1.5 bg-white bg-opacity-10"
                        >
                            <span class="flex-shrink-0">⚠️</span>
                            <span>
                                Reemplaza las unidades actuales por las del
                                archivo. Úsala solo si estás completamente
                                seguro de que esos son los valores correctos.
                            </span>
                        </div>

                        <div
                            class="mt-3 text-center text-sm font-semibold text-white"
                        >
                            Ir a la herramienta →
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InventoriesMassive"
};
</script>
